module.exports = __webpack_public_path__ + "img/avatar-s-26.d1c0b48d.png";